import { render, staticRenderFns } from "./PhoneModal.vue?vue&type=template&id=72b16807"
import script from "./PhoneModal.vue?vue&type=script&lang=js"
export * from "./PhoneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports